import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { InnerBlocks } from '@wordpress/block-editor';
export default function PostTemplateSave() {
  return createElement(InnerBlocks.Content, null);
}
//# sourceMappingURL=save.js.map